import * as firebase from 'firebase/app'

import { auth, db } from '../config/firebase'
import { addEvent } from './events'

export const addRoll = async (campaignId, characterName, roll, description, skillIndex) => {
  console.log('[addRoll] User', characterName, 'is adding roll for campaignId', campaignId, ':', roll)
  const data = {
    roll,
    skillIndex,
    owner: auth.currentUser.uid,
    displayName: characterName,
    created: firebase.firestore.FieldValue.serverTimestamp()
  }

  if (typeof description === 'string' && description.length > 0) {
    data.description = description
  }

  const rollRef = await db.collection('campaigns').doc(campaignId).collection('rolls').add(data)

  console.log('[addRoll] Created roll for campaignId', campaignId)

  return rollRef
}

export const updateRollDescription = async (campaignId, rollId, description) => {
  console.log('[updateRollDescription] Updating roll description for campaignId', campaignId, ':', rollId)

  const rollRef = await db.collection('campaigns').doc(campaignId).collection('rolls').doc(rollId).set({
    description,
    updated: firebase.firestore.FieldValue.serverTimestamp()
  }, { merge: true })

  console.log('[updateRollDescription] Updated roll description for campaignId', campaignId, ':', rollId)

  return rollRef
}

export const deleteRoll = async (campaignId, rollId) => {
  console.log('[addRoll] Deleting roll for campaignId', campaignId, ':', rollId)

  const rollRef = await db.collection('campaigns').doc(campaignId).collection('rolls').doc(rollId).delete()

  console.log('[deleteRoll] Deleted roll for campaignId', campaignId, ':', rollId)

  return rollRef
}

export const updateDestinyPool = async (campaignId, characterName, action, key) => {
  return new Promise((resolve, reject) => {
    const campaignRef = db.collection('campaigns').doc(campaignId)

    console.log('[updateDestinyPool] User', characterName, 'is updating destiny for campaignId', campaignId)

    db.runTransaction(function(transaction) {
      // This code may get re-run multiple times if there are conflicts.
      return transaction.get(campaignRef).then(async function(campaignDoc) {
          if (!campaignDoc.exists) {
            throw new Error('Document does not exist!')
          }

          const currentCampaignData = campaignDoc.data()
          let pool = currentCampaignData.destinyPool || {}
          const currPoolIdx = Object.keys(pool).length - 1
          let text = ''

          switch (action) {
            case 'addLight':
              pool[currPoolIdx + 1] = 1
              text = 'Added a light destiny point'
              break
            case 'addDark':
              pool[currPoolIdx + 1] = 0
              text = 'Added a dark destiny point'
              break
            case 'toggle': {
              pool[key] = pool[key] === 1 ? 0 : 1
              text = `Flipped a ${pool[key] === 1 ? 'dark' : 'light'} destiny point`
              break
            }
            case 'multi': {
              key.forEach((action, idx) => {
                pool[currPoolIdx + idx + 1] = action === 'addLight' ? 1 : 0
              })
              break
            }
            case 'clear':
              pool = {}
              text = 'Cleared the destiny pool'
              break
            case 'remove': {
              text = `Removed a ${pool[currPoolIdx] === 0 ? 'dark' : 'light'} destiny point`
              delete pool[currPoolIdx]
              break
            }
            default:
              break
          }

          transaction.update(campaignRef, { destinyPool: pool })
          if (text.length > 0) await addEvent(campaignId, characterName, { text })
          return pool
      });
    }).then(function(destinyPool) {
      console.log('[updateDestinyPool] Updated destiny for campaignId', campaignId)
        resolve(destinyPool)
    }).catch(function(error) {
        console.log('[updateDestinyPool] Transaction failed:', error)
        reject()
    })
  })
}
